<template>
  <div class="popup_wrap tax_invoice_request_pop" style="width:600px;">
    <button class="layer_close" @click.prevent="$emit('close')">close</button>

    <div class="popup_cont">
      <!-- popup_cont -->
      <h1 class="page_title">{{ $t('msg.ADD20260813.001') }}</h1>

      <div class="content_box">
        <!-- content_box -->
        <table class="tbl_row">
          <colgroup>
            <col width="160px"><col width="*">
          </colgroup>
          <tbody>
            <tr>
              <th>{{ $t('msg.ADD20260813.009') }}</th>
              <td>
                <span class="font_medium">{{ blNoList.length }} {{ $t('msg.ADD20260813.010') }}</span>
                <p v-if="blNoList.length > 0" class="txt_desc none">{{ blNoList.join(', ') }}</p>
              </td>
            </tr>
            <tr>
              <th>{{ $t('msg.ADD20260813.011') }}</th>
              <td>
                <input
                  type="text"
                  id="taxInvReqCompNm"
                  maxlength="100"
                  v-model.trim="params.cstName"
                >
              </td>
            </tr>
            <tr>
              <th>{{ $t('msg.ADD20260813.012') }}</th>
              <td>
                <input
                  type="text"
                  id="taxInvReqEmlAddr"
                  maxlength="100"
                  v-model.trim="params.emlAddr"
                >
              </td>
            </tr>
            <tr>
              <th>{{ $t('msg.ADD20260813.013') }}</th>
              <td>
                <p>
                  <input type="radio" id="taxInvReqCurCny" name="taxInvReqCur" v-model="params.invMethod" value="01">
                  <label for="taxInvReqCurCny"><span></span>{{ $t('msg.ADD20260813.014') }}</label>
                </p>
                <p class="txt_desc none">{{ $t('msg.ADD20260813.015') }}</p>
                <p class="mt5">
                  <input type="radio" id="taxInvReqCurSep" name="taxInvReqCur" v-model="params.invMethod" value="02">
                  <label for="taxInvReqCurSep"><span></span>{{ $t('msg.ADD20260813.016') }}</label>
                </p>
                <p class="txt_desc none">{{ $t('msg.ADD20260813.017') }}</p>
              </td>
            </tr>
            <!-- Settlement Ex. Rate: CNY Invoice(01) 선택 시에만 표시, 고객 수정 불가(읽기 전용) -->
            <tr v-if="params.invMethod === '01'">
              <th>{{ $t('msg.ADD20260813.018') }}</th>
              <td>
                <span class="color_red font_medium">{{ exRateText }}</span>
                <p class="txt_desc none">{{ $t('msg.ADD20260813.019') }}</p>
              </td>
            </tr>
          </tbody>
        </table>
      </div><!-- content_box // -->

      <div class="mt10 text_center">
        <a class="button blue lg" href="javascript:void(0)" @click.prevent="submit()">{{ $t('msg.ADD20260813.020') }}</a>
        <a class="button gray lg" href="javascript:void(0)" @click.prevent="$emit('close')">{{ $t('msg.ADD20260813.021') }}</a>
      </div>
    </div><!-- popup_cont -->
  </div><!-- popup_wrap // -->
</template>

<script>
import CalcIssue from '@/api/rest/settle/calcIssue'
import { taxInvoiceFailMessageKey } from '@/plugins/taxInvoiceRequest'

export default {
  name: 'TaxInvoiceRequestPop',
  props: {
    parentInfo: {
      type: Object,
      default: function () {
        return {
          blNoList: [],
          exRate: ''
        }
      }
    }
  },
  data () {
    return {
      isSubmitting: false,
      params: {
        cstName: '',
        emlAddr: '',
        invMethod: '01' // 01: CNY Consolidated / 02: CNY & USD Separate
      }
    }
  },
  computed: {
    blNoList () {
      return this.parentInfo.blNoList || []
    },
    exRateText () {
      return this.$ekmtcCommon.isNotEmpty(this.parentInfo.exRate) ? this.parentInfo.exRate : '-'
    }
  },
  methods: {
    async submit () {
      if (!this.$ekmtcCommon.isNotEmpty(this.params.cstName)) {
        this.openAlert(this.$t('msg.ADD20260813.022'))
        return
      }
      if (!this.$ekmtcCommon.isNotEmpty(this.params.emlAddr)) {
        this.openAlert(this.$t('msg.ADD20260813.023'))
        return
      }
      if (!this.$ekmtcCommon.checkEmail(this.params.emlAddr)) {
        this.openAlert(this.$t('msg.SETT010T010.205')) // 이메일 형식을 확인해 주세요.
        return
      }

      if (this.isSubmitting) {
        return
      }
      this.isSubmitting = true

      const reqData = {
        ...this.params,
        blNoList: this.blNoList
      }

      try {
        // 200 = SUBMITTED (그 외 상태는 catch로 떨어짐)
        const res = await CalcIssue.submitTaxInvoiceRequest(reqData)

        this.openAlert(this.$t('msg.ADD20260813.024'))
        this.$emit('callback', res.data)
      } catch (err) {
        const errData = err.response ? err.response.data : null

        // 409 VALIDATION_FAILED = Submit 시점 재검증 실패 (팝업 오픈 후 B/L 상태가 바뀐 경우)
        if (errData && errData.code === 'VALIDATION_FAILED') {
          let msg = this.$t('msg.ADD20260813.007') + '<br><br>'
          errData.failList.forEach(f => {
            msg += `${f.blNo} : ${this.$t(taxInvoiceFailMessageKey(f.status))}<br>`
          })
          this.openAlert(msg)
          return
        }

        // 서버 오류(5xx 등)
        console.log(err)
        this.openAlert(this.$t('msg.ADD20260813.025'))
      } finally {
        this.isSubmitting = false
      }
    },
    openAlert (msg) {
      const obj = {
        alertType: 'simple',
        customCloseBtnClass: 'button blue lg',
        customCloseBtnText: this.$t('msg.CSBK100.137'), // 확인
        useIcon: false,
        customClass: 'simple_alert',
        message: msg,
        type: 'info'
      }
      this.$ekmtcCommon.alert(obj)
    }
  }
}
</script>

<style scoped>
.tax_invoice_request_pop .content_box {
  height: auto !important;
  min-height: 0 !important;
}
</style>
